import Avatar from '@mui/material/Avatar'
import type { AvatarProps } from '@mui/material/Avatar'

import { getInitials } from '@/lib/get-initials'

export interface UserAvatarProps extends Omit<AvatarProps, 'src'> {
	name?: string | null
	src?: string | null
}

export function UserAvatar({ name, src, alt, children, ...props }: UserAvatarProps) {
	return (
		<Avatar alt={alt ?? name ?? undefined} src={src || undefined} {...props}>
			{children ?? (getInitials(name) || undefined)}
		</Avatar>
	)
}
